const activeValue = document.getElementById("dropdownMenu");
const posts = document.querySelectorAll(".past-sessions__year");
const options = document.querySelectorAll(".dropdown-item");
options.forEach(option => {
    option.addEventListener("click", function(e) {
        activeValue.innerHTML = e.target.innerHTML;
        activateYear();
    })
})

function activateYear() {
    const years = document.querySelectorAll('[data-year]');
    years.forEach(year => {
        if(year.dataset.year == activeValue.innerHTML) {
            year.classList.add("past-sessions__year--active");
        }
        else {
            year.classList.remove("past-sessions__year--active");
        }
    })
}
